import React, { FC } from 'react';
import { CircleButton } from '@ui';
import { CircleChannelIcon } from '@icons';
import { ChatRoleSettingsType } from '@app/interfaces/chat-roles-settings.type';
import { TableColumn, TableItem } from '@app/components/rubber-table/table.types';
import RubberTable from '@app/components/rubber-table';
import useTranslation from '@app/hooks/use-translation';

type ChatTablePropsType = {
  tableData: ChatRoleSettingsType[];
  isLoading?: boolean;
  onEditIconClick: (id: string) => void;
  onDeleteIconClick: (id: string) => void;
};

const ChatRolesTableBlock: FC<ChatTablePropsType> = (props) => {
  const { t } = useTranslation('pages.settings');
  const { tableData, isLoading, onEditIconClick, onDeleteIconClick } = props;
  const tableRecognitionColumns: Array<TableColumn> = [
    { index: 'name', title: t('common_setting.table.name') },
    { index: 'channel', title: t('common_setting.chatRoles.alias') },
    { index: 'actions', title: t('common_setting.table.actions'), maxWidth: 110, divider: 'left' },
  ];
  const tableRecognitionValues: Array<TableItem> = tableData.map((item) => ({
    name: (
      <div className="flex items-center text-[14px] h-full font-[700] text-0color">
        <CircleChannelIcon size={22} className="text-action mr-[10px]" />
        {item.name}
      </div>
    ),
    channel: (
      <div className="inline-flex items-center text-[14px] font-[400] text-0color">
        {item.alias?.name}
      </div>
    ),
    actions: (
      <div className="inline-flex items-center">
        <CircleButton
          onClick={() => onEditIconClick(item.crole_id || '')}
          className="mr-[20px] text-1color"
          hintTitle={t('alias.popup_hints.setting')}
          size={18}
          dataId={`channel-${item.name}-configure`}
          icon="SettingIcon"
        />
        <CircleButton
          onClick={() => onDeleteIconClick(item.crole_id || '')}
          hintTitle={t('alias.popup_hints.delete')}
          className="text-basic_red"
          size={18}
          dataId={`channel-${item.name}-delete`}
          icon="TrashIcon"
        />
      </div>
    ),
  }));
  return (
    <RubberTable
      isPending={isLoading}
      columns={tableRecognitionColumns}
      dataSource={tableRecognitionValues}
    />
  );
};

export default ChatRolesTableBlock;
